import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vi-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViContentComponent implements OnInit {
  @Input() gap: string = '24px';
  @Input() height: string;
  @Input() layoutAlign: string;
  @Input() direction: string = 'col';
  @Input() wrap: boolean = false;
  @Input() fluid: boolean;
  @Input() twoColumns: boolean;
  @Input() centered: boolean;
  @Input() contentWidth = '1064px';

  ngOnInit(): void {
    if (!this.layoutAlign) {
      this.layoutAlign = this.centered
        ? 'justify-center items-center'
        : 'justify-start items-start';
    }
  }
}
